<form *ngIf="form" [formGroup]="form">
       <nuc-form-field label="Role name">
           <nuc-input [autofocus]="true" formControlName="name" placeholder="Fill in the role name"></nuc-input>
           <nuc-error *ngIf="form.touched && form.controls.name.errors?.required">{{validationMessages.name.required}}</nuc-error>
       </nuc-form-field>
</form>


